import { Nil, ParsedPreset } from '@aibees/shared/definition';
import {
  TransferListConfig,
  TransferListGroupItems,
  TransferListItem,
  TransferListType,
} from '@aibees/shared/features/transfer-list';
import { AdvanceTableConfig } from '../../types';
import { TableLayoutTemplate } from '../table-layout-modifier-dialog';

export function obtainTableModifierDataFromConfig(
  config: AdvanceTableConfig,
  groupedItems?: TransferListGroupItems[]
): TransferListConfig {
  const items = config?.columns.map(
    (x) =>
      ({
        id: String(x.key ?? x.id),
        label: x.label,
        title: x.label,
        type: x.metadata?.type as TransferListType,
        icon: x.metadata?.icon,
        iconColor: x.metadata?.color,
        disable: x.disabledInColumnModifier,
        excluded: x.excludeFromColumnModifier,
      } as TransferListItem)
  );
  return {
    items,
    sortable: true,
    groupedItems,
  };
}

export function obtainTableModifierData(
  config: AdvanceTableConfig,
  preset?: Nil<ParsedPreset<TableLayoutTemplate>>
) {
  if (!preset) return obtainTableModifierDataFromConfig(config);

  const items = preset.value.columns?.map(
    (x) =>
      ({
        id: String(x.id),
        label: x.label,
        title: x.label,
        type: x.type as TransferListType,
        icon: x?.icon,
        iconColor: x?.iconColor,
        disable: x.disable,
        excluded: x.excluded,
      } as TransferListItem)
  );
  return {
    items,
    sortable: true,
  };
}
